import React from "react"
import { defPath, fetchPath } from '../../config/defPath'
import { useCartStore } from '../../hooks/useCartStore'
import { useFetch } from "../../hooks/useFetch"
import { useGeneralConfig } from "../../hooks/useGeneralConfig"

export const CartBtn = () => {
    const cart = useCartStore(state => state.cart)
    const openCart = useCartStore(state => state.openCart)

    const handleOpenCart = () => {
        openCart()

        const stateCart = cart.length > 0 ? 'Full' : 'Empty'

        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `Shopping Cart_${stateCart}`, // Full or Empty
            'interaction':'true',
            'component_name': 'Modo_Carrera_Tada',
            'element_text': 'Tu Carrito',
        });
    }

    return (
        <div className="ar__tadaShop__cartBtn" onClick={handleOpenCart}>
            <picture className="ar__tadaShop__cartBtn--picture">
                <img src={`${defPath}/assets/images/tadashop/shopping_cart.png`} alt="" />
                {
                    cart.length > 0 && (
                        <div className="ar__tadaShop__cartBtn--counter">{cart.length}</div>
                    )
                }
            </picture>
            <div className="ar__tadaShop__cartBtn__name">Tu Carrito</div>
        </div>
    )
}



